/*
 * Action Types
 */
export enum ProfilesTypes {
  LIST_PROFILES_REQUEST = '@profiles/LIST_PROFILES_REQUEST',
  LIST_PROFILES_SUCCESS = '@profiles/LIST_PROFILES_SUCCESS',
  LIST_PROFILES_FAILURE = '@profiles/LIST_PROFILES_FAILURE',

  FILTER_PROFILES_REQUEST = '@profiles/FILTER_PROFILES_REQUEST',
  FILTER_PROFILES_SUCCESS = '@profiles/FILTER_PROFILES_SUCCESS',
  FILTER_PROFILES_FAILURE = '@profiles/FILTER_PROFILES_FAILURE',

  GET_PROFILE_REQUEST = '@profiles/GET_PROFILE_REQUEST',
  GET_PROFILE_SUCCESS = '@profiles/GET_PROFILE_SUCCESS',
  GET_PROFILE_FAILURE = '@profiles/GET_PROFILE_FAILURE',

  CREATE_PROFILE_REQUEST = '@profiles/CREATE_PROFILE_REQUEST',
  CREATE_PROFILE_SUCCESS = '@profiles/CREATE_PROFILE_SUCCESS',
  CREATE_PROFILE_FAILURE = '@profiles/CREATE_PROFILE_FAILURE',

  UPDATE_PROFILE_REQUEST = '@profiles/UPDATE_PROFILE_REQUEST',
  UPDATE_PROFILE_SUCCESS = '@profiles/UPDATE_PROFILE_SUCCESS',
  UPDATE_PROFILE_FAILURE = '@profiles/UPDATE_PROFILE_FAILURE',

  DELETE_PROFILE_REQUEST = '@profiles/DELETE_PROFILE_REQUEST',
  DELETE_PROFILE_SUCCESS = '@profiles/DELETE_PROFILE_SUCCESS',
  DELETE_PROFILE_FAILURE = '@profiles/DELETE_PROFILE_FAILURE',

  UPDATE_ORDER_PROFILE_REQUEST = '@profiles/UPDATE_ORDER_PROFILE_REQUEST',
  UPDATE_ORDER_PROFILE_SUCCESS = '@profiles/UPDATE_ORDER_PROFILE_SUCCESS',
  UPDATE_ORDER_PROFILE_FAILURE = '@profiles/UPDATE_ORDER_PROFILE_FAILURE',

  LIST_PROFILE_LINES_REQUEST = '@profiles/LIST_PROFILE_LINES_REQUEST',
  LIST_PROFILE_LINES_SUCCESS = '@profiles/LIST_PROFILE_LINES_SUCCESS',
  LIST_PROFILE_LINES_FAILURE = '@profiles/LIST_PROFILE_LINES_FAILURE',

  GET_CID_REQUEST = '@profiles/GET_CID_REQUEST',
  GET_CID_SUCCESS = '@profiles/GET_CID_SUCCESS',
  GET_CID_FAILURE = '@profiles/GET_CID_FAILURE',

  SET_CURRENT_OPERATION = '@profiles/SET_CURRENT_OPERATION',

  SET_PROFILE_SELECTED = '@profiles/SET_PROFILE_SELECTED',
  RESET_PROFILE_SELECTED = '@profiles/RESET_PROFILE_SELECTED',
}

/*
 * Data types
 */
export interface FieldsInterface {
  resourceType: string;
  maximumAge?: number;
  minimumAge?: number;
  start?: string;
  end?: string;
}

export interface ParametersInterface {
  typeOfOperator: string;
  fields?: FieldsInterface;
}

export interface DataInterface {
  resourceType: string;
  parameters?: ParametersInterface;
}
export interface CreditsByFareInterface {
  fareId: string;
  quantity: number;
  timing: number;
}

export interface ProfileInterface {
  id: string;
  name: string;
  singleTicket?: boolean;
  allowSeatReservation?: boolean;
  qrcodeDisabled?: boolean;
  expiresOnBirthdate?: boolean;
  paymentTypeSingleTicket?: string | null;
  type: number;
  order: number;
  status: number;
  expires: number;
  facial: boolean;
  description: string;
  expiresDate: null | number;
  autoApprove: boolean;
  bdosOnly: boolean;
  hasSubsidy: boolean;
  validateCredit: boolean;
  allowCreditsByFare: CreditsByFareInterface | null;
  walletChargeValue: number | string;
  walletChargeTiming: number | string;
  walletChargeTimingType?: number | null;
  data: string; // json
  transportOperatorId: string;
  createdAt: string;
  updatedAt?: string;
}

export interface ProfileLineInterface {
  lineId: string;
  name: string;
  prefix: string;
  active: boolean;
  color: string;
  // type: number;
}

export interface CidInterface {
  name: string;
}

export type OperationTypes = 'none' | 'create' | 'edit';

/*
 * State type
 */
export interface ProfilesState {
  readonly profilesList: ProfileInterface[];
  readonly filterProfilesList: ProfileInterface[];
  readonly profileData: ProfileInterface;
  readonly profileCreated: ProfileInterface;
  readonly profileSelected: ProfileInterface;
  readonly currentOperation: OperationTypes;
  readonly profileOrder: ProfileInterface[];
  readonly profileLines: ProfileLineInterface[];
  readonly cid: CidInterface;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
